import React, { useEffect, createElement } from 'react';
import AdvertorialGlp6TipsC from '../components/AdvertorialGlp6TipsC';
import { HelmetProvider, Helmet } from 'react-helmet-async';
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq: any;
  }
}
export function Glp6TipsCPage() {
  useEffect(() => {
    // Initialize Facebook Pixel with safety checks
    !function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      // Safety check: if no script elements exist, append to head instead
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // Initialize with Pixel ID
    window.fbq('init', '9567705179928833');
    window.fbq('track', 'PageView');
    // Track ViewContent for this advertorial
    window.fbq('track', 'ViewContent', {
      content_name: '6 Essential Tips for GLP-1 Users',
      content_category: 'Health',
      content_type: 'article'
    });
    // Store fbclid in localStorage if present in URL
    const params = new URLSearchParams(window.location.search);
    const fbclid = params.get('fbclid');
    if (fbclid) {
      localStorage.setItem('fbclid', fbclid);
    }
    // Set up scroll depth tracking
    let tracked50 = false;
    let tracked90 = false;
    const handleScroll = () => {
      const scrollPercent = window.scrollY / (document.body.scrollHeight - window.innerHeight) * 100;
      if (!tracked50 && scrollPercent > 50) {
        window.fbq('trackCustom', 'Advertorial_Scroll_50');
        tracked50 = true;
      }
      if (!tracked90 && scrollPercent > 90) {
        window.fbq('trackCustom', 'Advertorial_Scroll_90');
        tracked90 = true;
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return <HelmetProvider data-id="element-18333" data-mp="3vc98bntyt0zw">
      <div className="w-full min-h-screen bg-gray-100" data-id="element-18334" data-mp="3vbheahg0nbbq">
        <Helmet data-id="element-18335" data-mp="3hlxe9jdtks64">
          <title data-id="element-18336" data-mp="3hle1si6xuvzh">The 6 Things Every GLP-1 User Needs to Know</title>
          <meta property="og:title" content="The 6 Things Every GLP-1 User Needs to Know" data-id="element-18337" data-mp="3mcdv7dgumvx8" />
          <meta property="og:description" content="After helping thousands of patients navigate GLP-1 medications, here are the critical insights that make all the difference between success and struggle." data-id="element-18338" data-mp="37nhphn29luzs" />
          <meta property="og:type" content="article" data-id="element-18339" data-mp="2yms0b27if2v1" />
          <meta property="og:url" content={window.location.href} data-id="element-18340" data-mp="2ynbeq8xyb94b" />
          <meta property="og:image" content="https://cdn.magicpatterns.com/uploads/gz84jYVasZBwWRkhgymjxp/b2QZCI4Ek7lGaGIZHSfBo.png" data-id="element-18341" data-mp="32omw5r6o8o1f" />
          <meta property="og:image:width" content="1200" data-id="element-18342" data-mp="2k0meu5zsetxe" />
          <meta property="og:image:height" content="630" data-id="element-18343" data-mp="2f1jf912ktfwt" />
          <meta property="og:site_name" content="Health Investigation Series" data-id="element-18344" data-mp="2f32q2c5gqyr7" />
          <meta name="twitter:card" content="summary_large_image" data-id="element-18345" data-mp="2t22hfrkd1rr2" />
          <meta name="twitter:title" content="The 6 Things Every GLP-1 User Needs to Know" data-id="element-18346" data-mp="2o1eov1ghh2uq" />
          <meta name="twitter:description" content="After helping thousands of patients navigate GLP-1 medications, here are the critical insights that make all the difference between success and struggle." data-id="element-18347" data-mp="32y5j6wbavodh" />
          <meta name="twitter:url" content={window.location.href} data-id="element-18348" data-mp="3bq7ekg6iiegw" />
          <meta name="twitter:image" content="https://cdn.magicpatterns.com/uploads/gz84jYVasZBwWRkhgymjxp/b2QZCI4Ek7lGaGIZHSfBo.png" data-id="element-18349" data-mp="37pxbpce0o469" />
        </Helmet>
        <AdvertorialGlp6TipsC data-id="element-18350" data-mp="3lpy9giyzivhi" />
      </div>
    </HelmetProvider>;
}